"use client";

import { c as _c } from "react/compiler-runtime";
import { createPayment } from "@/actions/payment";
import ReceiptDropzoneField from "@/components/form/receipt-dropzone-field";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import ButtonWithLoader from "@/components/utility/button-with-loader";
import { capturePixelEvent } from "@/lib/pixel";
import { GENDER, TCourse, ZPaymentCreateSchema } from "@/types/types";
import { paymentCreateSchema } from "@/types/zod-types";
import { cn, pleaseWait } from "@/utils/helpers";
import { tryCatch } from "@/utils/validators";
import { useAuth } from "@clerk/nextjs";
import { zodResolver } from "@hookform/resolvers/zod";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "sonner";
import ThankYouDrawer from "./thank-you-drawer";
type PaymentFormProps = {
  course: TCourse;
  className?: string;
};
export default function PaymentForm(t0) {
  const $ = _c(36);
  const {
    course,
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      resolver: zodResolver(paymentCreateSchema)
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const form = useForm(t1);
  const {
    control,
    handleSubmit,
    reset,
    formState: t2
  } = form;
  const {
    isDirty,
    isSubmitting
  } = t2;
  const [showThankYouDrawer, setShowThankYouDrawer] = useState(false);
  const {
    userId
  } = useAuth();
  let t3;
  if ($[1] !== course || $[2] !== reset || $[3] !== userId) {
    t3 = async function handleCreate(formData) {
      if (!userId) {
        toast.warning("Please sign in to make a payment.");
        return;
      }
      if (!course.originalPrice) {
        throw new Error("Course price has not been set yet.");
      }
      const {
        data: createdPayment,
        error
      } = await tryCatch(createPayment(formData, course.id));
      if (error) {
        toast.error(error.message);
        return;
      }
      capturePixelEvent("AddPaymentInfo", {
        content_name: course.title,
        content_category: "Course",
        content_type: "course",
        content_ids: [course.id],
        value: course.discountedPrice ? course.discountedPrice : course.originalPrice,
        currency: createdPayment.currency
      });
      setShowThankYouDrawer(true);
      reset();
    };
    $[1] = course;
    $[2] = reset;
    $[3] = userId;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleCreate = t3;
  let t4;
  if ($[5] !== handleCreate || $[6] !== handleSubmit) {
    t4 = handleSubmit(handleCreate);
    $[5] = handleCreate;
    $[6] = handleSubmit;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== className) {
    t5 = cn("mx-auto w-full items-center gap-4 py-4", className);
    $[8] = className;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[10] !== control) {
    t6 = <FormField control={control} name="phoneNumber" render={_temp} />;
    t7 = <FormField control={control} name="city" render={_temp2} />;
    t8 = <FormField control={control} name="age" render={_temp3} />;
    t9 = <FormField control={control} name="gender" render={_temp5} />;
    $[10] = control;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
  } else {
    t6 = $[11];
    t7 = $[12];
    t8 = $[13];
    t9 = $[14];
  }
  let t10;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <ReceiptDropzoneField formFieldKey="receiptImageId" />;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  const t11 = !isDirty || isSubmitting;
  let t12;
  if ($[16] !== isSubmitting || $[17] !== t11) {
    t12 = <ButtonWithLoader type="submit" pending={isSubmitting} disabled={t11} className="mt-8 w-full">Submit</ButtonWithLoader>;
    $[16] = isSubmitting;
    $[17] = t11;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t12 || $[20] !== t6 || $[21] !== t7 || $[22] !== t8 || $[23] !== t9) {
    t13 = <div className="space-y-4">{t6}{t7}{t8}{t9}{t10}{t12}</div>;
    $[19] = t12;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t13 || $[26] !== t4 || $[27] !== t5) {
    t14 = <form onSubmit={t4} className={t5}>{t13}</form>;
    $[25] = t13;
    $[26] = t4;
    $[27] = t5;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = async () => {
      setShowThankYouDrawer(false);
      await pleaseWait(0.5);
      document.getElementById("enroll")?.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    };
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== showThankYouDrawer) {
    t16 = <ThankYouDrawer title={"\uD83C\uDF89 Thank you for enrolling!"} subtitle="Your payment confirmation request has been sent. You will receive an approval email within 24 hours." showDrawer={showThankYouDrawer} setShowDrawerAction={setShowThankYouDrawer} onCloseAction={t15} />;
    $[30] = showThankYouDrawer;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== form || $[33] !== t14 || $[34] !== t16) {
    t17 = <Form {...form}>{t14}{t16}</Form>;
    $[32] = form;
    $[33] = t14;
    $[34] = t16;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  return t17;
}

// Recycled

// try {
//   const response = await fetch(`${PROJECT_URL}/api/email/payment-approval-request`, {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//     },
//     body: JSON.stringify({ payment: result.data }),
//   });

//   if (!response.ok) {
//     throw new Error(`API Error: ${response.statusText}`);
//   }
// } catch (error) {
//   console.error("Error:", error);
//   toast.error("An error occured while sending the email");
// } finally {
//   setShowDrawer(true);
//   reset();
// }
function _temp5(t0) {
  const {
    field: field_2
  } = t0;
  return <FormItem><FormLabel>Gender</FormLabel><Select onValueChange={field_2.onChange}><FormControl><SelectTrigger><SelectValue placeholder={field_2.value ?? "Select gender"} /></SelectTrigger></FormControl><SelectContent align="start" className="max-w-52">{GENDER.map(_temp4)}</SelectContent></Select><FormMessage /></FormItem>;
}
function _temp4(gender) {
  return <SelectItem key={gender.id} value={gender.id} className="max-w-48">{gender.title}</SelectItem>;
}
function _temp3(t0) {
  const {
    field: field_1
  } = t0;
  return <FormItem><FormLabel>Age</FormLabel><FormControl><Input {...field_1} value={field_1.value || ""} type="number" placeholder="10 - 100" /></FormControl><FormMessage /></FormItem>;
}
function _temp2(t0) {
  const {
    field: field_0
  } = t0;
  return <FormItem><FormLabel>City</FormLabel><FormControl><Input {...field_0} value={field_0.value || ""} placeholder="e.g. Lahore" /></FormControl><FormMessage /></FormItem>;
}
function _temp(t0) {
  const {
    field
  } = t0;
  return <FormItem><FormLabel>Phone Number</FormLabel><FormControl><Input {...field} value={field.value || ""} type="tel" placeholder="e.g. 03171234567" /></FormControl><FormMessage /></FormItem>;
}
{
  /* Payment Method */
}
{
  /* <FormField
  control={control}
  name="paymentMethod"
  render={({ field }) => (
  <FormItem>
    <FormLabel>Payment Method (Optional)</FormLabel>
    <Select
      onValueChange={(value: PaymentMethod) => setValue("paymentMethod", value, { shouldDirty: true })}
    >
      <FormControl>
        <SelectTrigger>
          <SelectValue placeholder="Select payment method" />
        </SelectTrigger>
      </FormControl>
      <SelectContent align="start" className="max-w-52">
        {PAYMENT_METHODS.map((item) => {
          return (
            <SelectItem key={item.id} value={item.id} className="max-w-48">
              {item.title}
            </SelectItem>
          );
        })}
      </SelectContent>
    </Select>
    <FormMessage />
  </FormItem>
  )}
  /> */
}